import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  ${'' /* min-height:478px; */}
  min-height: ${({ hideHeaders, minHeight }) => (minHeight?minHeight: hideHeaders ? "476px" : "514px")};
  display: block;
  padding: 16px;
  ${'' /* padding: ${({paddingM}) => paddingM ? paddingM : '16px 16px 8px 16px'}; */}
  background: ${({ background }) => (background?background: "white")};
  border-radius: 12px;
  margin: 0;
  font-family: 'Lato';

  .heading {
    color: #184a61;
    font-family: 'Lato';
    font-size: 18px;
    font-weight: 700;
    padding-bottom: 20px;
    line-height: 24px;
    margin-bottom: ${({ margin }) => (margin?margin: "20px")};
    border-bottom: 1px solid #efefef;
    display: flex;
    align-items: center;
  }

  .type {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: #f8f8f8;
    margin-bottom: 12px;
    padding: 4px;
    border-radius: 4px;

    .name {
      color: #116d8d;
      font-size: 16px;
      font-weight: 400;
    }

    .value {
      color: #116d8d;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .item {
    width: 100%;
    display: flex;
    padding: ${({ isPadding }) => (isPadding ? "20px 0px" : "8px 0px")};
    ${'' /* padding: 20px 0; */}
    border-bottom: 1px solid #efefef;
    justify-content: space-between;
    align-items: center; /* Ensures proper alignment */
    gap: 8px;

    .item-left {
      display: flex;
      align-items: center;
      gap: 8px; /* Ensures gap between image and name */
    }
   

    .profile {
     width: 48px;
     height: 48px;
     ${'' /* border: 1px solid #dcdcdc; */}
     ${'' /* border-radius: 50%; */}
     flex-shrink: 0; /* Prevents shrinking */

      > img {
        width: 48px;
        height: 48px;
        border: 1px solid #dcdcdc;
        border-radius:40px;
      }
    }

    .name {
      color: #184a61;
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }

    .value {
      color: #184a61;
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
      margin-right:8px;
      width: ${({ widthD }) => (widthD?widthD: "")};
    }
  }

  .showmore {
    width: 100%;
    display: flex;
    padding: 8px 4px;

    .button {
      color: #184a61;
      font-size: 16px;
      font-weight: 400;
      padding: 6px 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .see{
      color: #184a61;
      font-size: 16px;
      font-weight: 400;
      padding: 0px 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-top:12px;
    }
  }
`;

export const ScrollableContainer = styled.div`
  max-height: ${({ height }) => height || "400px"};
  overflow-y: ${({ showAllRows }) => (showAllRows ? "auto" : "hidden")};

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background-color: #ffffff;
    border-radius: 4px;
  }

  .no-data{
    text-align: center; 
    margin-top: 20px; 
    color: rgb(24, 74, 97); 
    font-size: 16px; 
    display: flex; 
    ${'' /* justify-content: center;  */}
    align-items: center; 
    font-family: Lato;
  }

  .no-initiative{
    display:flex;
    align-items:center;
    margin:auto;
    flex-wrap:wrap;
    .nodata{
      text-align: center; 
      margin-top: 20px; 
      color: rgb(24, 74, 97); 
      font-size: 16px; 
      display: flex; 
      ${'' /* justify-content: center;  */}
      align-items: center; 
      font-family: Lato;
      width:100%;
      justify-content:center;
      margin:100px 0;
    }
  }

  .content-wrap{
    display:block;
    .name{
      font-family: Lato;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #184A61;      
    }
    .department{
      font-family: Lato;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #BDBDBD; 
      margin-top:8px;     
    }
  }
`;
